module.exports = __webpack_public_path__ + "img/28_70.c211f86a.png";